import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post(`/driver-shift/slot/bulk-update-capacity`, payload);
  },
  getBulkUploadUrl(payload) {
    return Api.post(
      `/driver-shift/slot/bulk-update-slot-daily-capacity`,
      payload
    );
  },
  getDriverSlotsExemptionUrl(payload) {
    return Api.post(`/driver-shift/slot/bulk-driver-slots-exempted`, payload);
  },
  getDriverStarGigsExemptionUrl(payload) {
    return Api.post(
      `/driver-shift/slot/bulk-driver-star-gigs-exempted`,
      payload
    );
  },
  getGigsBulkOptOutUrl(payload) {
    return Api.post(`/driver-shift/slot/bulk-driver-gigs-opt-out`, payload);
  },
  getGigsBulkOptInUrl(payload) {
    return Api.post(`/driver-shift/slot/bulk-driver-gigs-opt-in`, payload);
  },
  getDriverGigsCancellationFeeUrl(payload) {
    return Api.post(
      `/driver-shift/slot/bulk-driver-slot-cancellation-fee-exempted`,
      payload
    );
  },
  getGigsCancellationFeeUrl(payload) {
    return Api.post(
      `/driver-shift/slot/bulk-slot-cancellation-fee-exempted`,
      payload
    );
  },
  getSlotsList(payload) {
    return Api.post(`/driver-shift/slot/list`, payload);
  },
  getActiveSlot(payload) {
    return Api.post(`/driver-shift/slot/details`, payload);
  },
};
